(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"));
	else if(typeof define === 'function' && define.amd)
		define(["leaflet"], factory);
	else if(typeof exports === 'object')
		exports["leaflet-ant-path"] = factory(require("leaflet"));
	else
		root["leaflet-ant-path"] = factory(root["L"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_12__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition